import {AbstractUpload} from "./AbstractUpload";
import {Injectable} from "@angular/core";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";
import {Monitoramento} from "../../../domain/Monitoramento";
import {MonitoramentoHttpService} from "../../persist/http/MonitoramentoHttpService";
import {Jornada} from "../../../domain/Jornada";

@Injectable()
export class UploadMonitoramento extends AbstractUpload<Monitoramento>{
  constructor(service: MonitoramentoHttpService) {
    super("Monitoramento", service, Monitoramento);
  }

  override async getPendencias(): Promise<any[]>{
    const repo = LocalDataSource.getRepository(Monitoramento)
    return repo.find({
      where: {situacao: EnumSincronizacao.ENVIAR},
      relations: ["metodos","jornada","projeto","campanha","local"]
    })
  }

  override transformBeforeSend(items: Monitoramento[]): any[]{
    items.forEach(i=>{
      delete i.situacao
      i.jornada = { id: i.jornada.id} as any
      i.metodos = i.metodos.map(m=> {
        return {id: m.id} as any
      })
      if(i.projeto) i.projeto = {id: i.projeto.id} as any
      if(i.local ) i.local = {id: i.local.id}
      if(i.campanha) i.campanha = {id: i.campanha.id}
    })
    return items
  }
}
